export const eventTextContent = {
  subtitleText: "Meet Us at the Following Event",
  dateText: "11-14",
  monthText: "January",
  btnText: "Book A Meeting",
  imageSrcSigma: "/assets/stock-img/sigma_logo_img.webp",
  imageSrc: "/assets/stock-img/event_rocket_img.webp",
};
